export default "__VITE_ASSET__DqLKMjXJ__"